export default "__VITE_PUBLIC_ASSET__529717cc__"